import React, { useEffect, useRef, useState } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Card,
  CardBody,
  Row,
  Col,
  CardFooter,
} from "reactstrap";
import FalconCardHeader from "../common/FalconCardHeader";

import WizardError from "../auth/register/WizardError";
import classNames from "classnames";
import ButtonIcon from "../common/ButtonIcon";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import SelectAdminRow from "../root/condominium/components/selectAdminRow";
import ButtonIconTooltip from "../common/ButtonIconTooltip";
import { faPaperclip } from "@fortawesome/free-solid-svg-icons";
import { PreloadState } from "../UI/preloading/PreloadState";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { getUsers } from "../../helpers/api/root";
import FullPagination from "../common/pagination/FullPagination";
import useSWRFetchPaginationProperty from "../../helpers/hooks/useSWRFetchPaginationProperty";
import { fetchCondominiums } from "../../helpers/api/condominium";
import CondominiumLocationFields from "../common/CondominiumLocationFields";

const capitalizeFirstLetter = (value) => {
  const text = (value || "").trim();
  return text ? `${text.charAt(0).toUpperCase()}${text.slice(1)}` : "";
};

const CreateCondominiumForm = ({ condominium, handleSubmitData }) => {
  const { role } = useSelector((state) => state.auth.user);
  const { token } = useSelector((state) => state.auth.user);
  const {
    register,
    handleSubmit,
    errors,
    formState: { isSubmitting },
    setValue,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    defaultValues: {
      state: condominium?.state || "",
      city: condominium?.city || "",
    },
  });
  const [location, setLocation] = useState({
    state: condominium?.state || "",
    city: condominium?.city || "",
  });
  const [acronym, setAcronym] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [selectedAdmin, setSelectedAdmin] = useState(null);
  const refInputImage = useRef(null);

  const [meta, setMeta] = useState({
    total: null,
    currentPage: 1,
    perPage: 5,
    from: null,
    to: null,
    lastPage: null,
  });

  console.log(errors);

  const { currentPage: page, perPage } = meta;

  const [params, setParams] = useState({
    search: null,
    token: token,
  });

  const {
    data: dataC,
    error,
    isLoading,
    mutate,
    meta: metaC,
    handler: {
      nextPage: nextPageC,
      previousPage: previousPageC,
      perPage: perPageC,
      goToPage: goToPageC,
    },
  } = useSWRFetchPaginationProperty(fetchCondominiums, params);

  console.log(dataC);

  const acronyns = dataC
    .filter(
      (item) =>
        !condominium || String(item.id) !== String(condominium.id)
    )
    .map((item) => item.acronym);

  console.log(acronyns);

  const nextPage = () => setMeta((prev) => ({ ...prev, page: page + 1 }));
  const previousPage = () => setMeta((prev) => ({ ...prev, page: page - 1 }));
  const goToPage = (page) => setMeta((prev) => ({ ...prev, page: page }));
  const handlePerPage = (perPageNumber) => {
    setMeta((prevs) => {
      return { ...prevs, perPage: perPageNumber };
    });
  };

  const [data, setData] = useState([]);

  useEffect(() => {
    let isMounted = true;
    if (condominium && role === "root") {
      isMounted && register("auth_id");
      isMounted && setValue("auth_id", condominium.manager.id);
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [condominium]);

  useEffect(() => {
    let isMounted = true;
    if (selectedAdmin) isMounted && setValue("auth_id", selectedAdmin);
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [selectedAdmin]);

  useEffect(() => {
    let isMounted = true;
    if (role === "root") {
      register("auth_id");
      !condominium &&
        getUsers(page, perPage, { role: "manager" })
          .then((data) => {
            isMounted && setData(data.data);
            isMounted &&
              setMeta({
                total: data.meta.total,
                currentPage: data.meta.current_page,
                lastPage: data.meta.last_page,
                perPage: data.meta.per_page,
                to: data.meta.to,
                from: data.meta.from,
              });
          })
          .catch((error) => handleErrorMessage(error));
    }
    return () => {
      isMounted = false;
    };
    // eslint-disable-next-line
  }, [role, page, perPage]);

  const renderAdminItems = () =>
    data.map((admin) => (
      <SelectAdminRow
        onSelect={setSelectedAdmin}
        selected={selectedAdmin}
        id={admin?.id}
        name={`${admin?.data?.firstname} ${admin?.data?.lastname}`}
        username={admin?.username}
        dni={admin?.data?.dni}
        alternativeName="administrador"
      />
    ));

  useEffect(() => {
    register("acronym");
    if (condominium) {
      setValue("acronym", condominium.acronym);
      if (!Boolean(condominium.image)) {
        setImagePreview(condominium.image);
      } else {
        setImagePreview(
          `${import.meta.env.VITE_URL}/storage/${condominium.image}`
        );
      }
      setAcronym(condominium.acronym);
    }
    // eslint-disable-next-line
  }, []);

  const handleImageChange = (event) => {
    if (event.target.files.length !== 0) {
      setImagePreview(URL.createObjectURL(event.target.files[0]));
      register("image");
      setValue("image", event.target.files[0]);
    }
  };

  const handleFormSubmit = (values) => {
    handleSubmitData({
      ...values,
      state: capitalizeFirstLetter(values.state),
      city: capitalizeFirstLetter(values.city),
    });
  };

  return (
    <Card
      data-testid="form"
      className="mb-3 bg-light"
      tag={Form}
      onSubmit={handleSubmit(handleFormSubmit)}
    >
      <PreloadState
        loading={isSubmitting}
        message={isSubmitting && "Guardando por favor espere..."}
      >
        <>
          <FalconCardHeader title="Detalles de condominio" light={false} />
          <CardBody>
            {!condominium && role === "root" && (
              <Row form>
                <Col tag={FormGroup}>
                  <Label>
                    Seleccione un administrador para registrar el condominio
                  </Label>
                  {renderAdminItems()}
                  <FullPagination
                    nextPage={nextPage}
                    prevPage={previousPage}
                    goToPage={goToPage}
                    meta={meta}
                    className={"shadow-none"}
                    posText={"administradores"}
                    perPage={handlePerPage}
                  />
                  {!selectedAdmin && (
                    <span
                      className={classNames(
                        "text-danger d-inline-block fs--1 font-weight-normal d-block"
                      )}
                    >
                      Debes seleccionar un administrador
                    </span>
                  )}
                </Col>
              </Row>
            )}

            {condominium && (
              <Row form>
                <Col tag={FormGroup}>
                  <Label for="title" className="d-block">
                    Foto del condominio
                  </Label>
                  <Input
                    type="file"
                    onChange={handleImageChange}
                    innerRef={refInputImage}
                    name="voucher"
                    id="voucher"
                    placeholder="Adjunte comprobante de pago"
                    className="form-control-file d-none"
                    accept="image/png, image/jpeg"
                  />
                  <ButtonIconTooltip
                    icon={faPaperclip}
                    color="falcon-default"
                    placement="right"
                    onClick={() =>
                      refInputImage.current && refInputImage.current.click()
                    }
                    id="imgpreview"
                  >
                    Adjuntar foto
                  </ButtonIconTooltip>
                </Col>
              </Row>
            )}

            {imagePreview && (
              <Row form className="d-flex justify-content-center">
                <Col
                  style={{
                    backgroundImage: `url(${imagePreview})`,
                    backgroundPosition: "center",
                    backgroundSize: "contain",
                    height: "400px",
                    width: "400px",
                    maxHeight: "400px",
                    maxWidth: "400px",
                    backgroundRepeat: "no-repeat",
                  }}
                ></Col>
              </Row>
            )}

            <Row form>
              <Col tag={FormGroup}>
                <Label for="title">Nombre del condominio</Label>
                <Input
                  autoComplete="off"
                  name="name"
                  defaultValue={condominium?.name}
                  className={classNames({
                    "border-danger": errors["name"]?.message,
                  })}
                  innerRef={register({
                    required: "Nombre del condominio es requerido.",
                    minLength: {
                      value: 4,
                      message:
                        "El nombre del condominio debe tener minimo 4 caracteres.",
                    },
                  })}
                  id="title"
                  placeholder="Nombre del condominio"
                />
                <WizardError
                  error={errors["name"]?.message}
                  className="fs--1 font-weight-normal d-block"
                />
              </Col>
            </Row>

            <Row form>
              <Col sm tag={FormGroup}>
                <Label for="identification">Documento de identificación</Label>
                <Input
                  autoComplete="off"
                  name="identification"
                  id="identification"
                  defaultValue={condominium?.identification}
                  className={classNames({
                    "border-danger": errors["identification"]?.message,
                  })}
                  placeholder="Documento de identificación"
                  innerRef={register({
                    required: "El Documento de identificación es requerido.",
                    minLength: {
                      value: 3,
                      message:
                        "El Documento de identificación debe ser igual o mayor a 3 caracteres.",
                    },
                    pattern: {
                      value: /^[a-zA-Z0-9_-]+$/i,
                      message: "Solo se aceptan alphanúmericos y (-).",
                    },
                  })}
                />
                <WizardError
                  error={errors["identification"]?.message}
                  className="fs--1 font-weight-normal d-block"
                />
              </Col>

              <Col sm tag={FormGroup}>
                <Label for="acronym">Acronimo</Label>
                <Input
                  maxLength="8"
                  autoComplete="off"
                  defaultValue={acronym}
                  placeholder="Acronimo"
                  name="acronym"
                  onChange={(event) => {
                    setAcronym(event.target.value.toUpperCase());
                    setValue("acronym", event.target.value.toUpperCase());
                  }}
                  className={classNames({
                    "border-danger": errors["acronym"]?.message,
                  })}
                  innerRef={register({
                    required: "Acronimo es requerido.",
                    minLength: {
                      value: 3,
                      message:
                        "El Acronimo debe ser igual o mayor a 3 caracteres.",
                    },
                    maxLength: {
                      value: 8,
                      message: "El Acronimo debe contener maximo 8 caracteres.",
                    },
                    pattern: {
                      value: /^[A-Z0-9]+$/i,
                      message: "Solo se aceptan alphanúmericos.",
                    },
                    validate: (value) => {
                      const exists = acronyns.includes(
                        (value || "").toUpperCase()
                      );
                      return !exists || "El acrónimo ya existe.";
                    },
                  })}
                />
                <WizardError
                  error={errors["acronym"]?.message}
                  className="fs--1 font-weight-normal d-block"
                />
              </Col>
            </Row>

            {!condominium && (
              <Row form>
                <Col tag={FormGroup}>
                  <Label for="properties">Número de propiedades</Label>
                  <Input
                    id="properties"
                    name="properties"
                    defaultValue={condominium?.properties}
                    type="number"
                    min="1"
                    placeholder="# Propiedades"
                    className={classNames({
                      "border-danger": errors["properties"]?.message,
                    })}
                    innerRef={register({
                      required: "El número de propiedades es requerido.",
                      min: {
                        value: 1,
                        message: "El mínimo de propiedades es de 1.",
                      },
                      pattern: {
                        value: /\d/i,
                        message: "Solo números son aceptados.",
                      },
                    })}
                  />
                  <WizardError
                    error={errors["properties"]?.message}
                    className="fs--1 font-weight-normal d-block"
                  />
                </Col>
              </Row>
            )}

            {!condominium && (
              <Row form>
                <Col tag={FormGroup}>
                  <Label for="base_currency">Moneda de trabajo</Label>
                  <Input
                    type="select"
                    id="base_currency"
                    name="base_currency"
                    defaultValue="USD"
                    innerRef={register}
                  >
                    <option value="USD">Dólar (USD)</option>
                    <option value="EUR">Euro (EUR)</option>
                  </Input>
                  <span className="fs--1 text-500 d-block mt-1">
                    Todos los montos de este condominio quedarán expresados
                    en esta moneda. No podrá cambiarse una vez que el
                    condominio tenga actividad registrada.
                  </span>
                </Col>
              </Row>
            )}

            <CondominiumLocationFields
              state={location.state}
              city={location.city}
              onStateChange={(state) => {
                setLocation({ state, city: "" });
                setValue("state", state, { shouldValidate: true });
                setValue("city", "", { shouldValidate: true });
              }}
              onCityChange={(city) => {
                setLocation((previous) => ({ ...previous, city }));
                setValue("city", city, { shouldValidate: true });
              }}
              stateInputRef={register({
                required: !condominium && "El estado es requerido.",
              })}
              cityInputRef={register({
                required:
                  (!condominium || location.state !== (condominium.state || "")) &&
                  "La ciudad es requerida.",
              })}
              stateError={errors.state?.message}
              cityError={errors.city?.message}
            />

            <Row form>
              <Col tag={FormGroup}>
                <Label for="address">Dirección</Label>
                <Input
                  id="address"
                  name="address"
                  defaultValue={condominium?.address}
                  type="textarea"
                  rows={6}
                  placeholder="Dirección"
                  className={classNames({
                    "border-danger": errors["address"]?.message,
                  })}
                  innerRef={register({
                    required: "La dirección es requerida.",
                    minLength: {
                      value: 10,
                      message:
                        "La dirección debe contener al menos 10 caracteres.",
                    },
                  })}
                />
                <WizardError
                  error={errors["address"]?.message}
                  className="fs--1 font-weight-normal d-block"
                />
              </Col>
            </Row>
          </CardBody>
          <CardFooter className={classNames("px-md-6 bg-light d-flex")}>
            <ButtonIcon
              data-testid="submit-button"
              color="primary"
              className="ml-auto px-5"
              type="submit"
              icon="save"
              iconAlign="right"
              /*  disabled={(Object.keys(errors).length > 0)} */
              transform="down-1 shrink-4"
            >
              Guardar
            </ButtonIcon>
          </CardFooter>
        </>
      </PreloadState>
    </Card>
  );
};

export default CreateCondominiumForm;
